module.exports = __webpack_public_path__ + "img/banner.97e3682e.png";